import './index.scss'
$("header .nav ul li").eq(3).addClass("active");
$(".right dl dt").click(function() {
    $(this).toggleClass("active");
    $(this).parent().find(".dd").slideToggle();
})